<template>
    <div class="px-5">
        <div class="row">
            <slot name="header"></slot>

            <div v-if="isLoaded && filterOptionsLoaded" class="col-md-12">
                <div
                    class="collapse"
                    :class="{ show: enableQuotesTable }"
                    id="filter-wrapper"
                >
                    <div class="card mb-4">
                        <div class="card-header">Inkludera</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-lg-6">
                                    <div class="row">
                                        <div class="col-12 col-md-6 mb-3">
                                            <strong>Datum (fr.o.m.)</strong>

                                            <input v-model="filterConfig.include.createdAt.min" type="date" class="form-control" :max="filterConfig.include.createdAt.max || undefined" />
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong>Datum (t.o.m.)</strong>
                                            <input v-model="filterConfig.include.createdAt.max" type="date" class="form-control" :min="filterConfig.include.createdAt.min || undefined" />
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong
                                                >Senaste kundaktivitet
                                                (fr.o.m.)</strong
                                            >

                                            <input v-model="filterConfig.include.latestCustomerInitiatedActionLogAt.min" type="date" class="form-control" :max="filterConfig.include.latestCustomerInitiatedActionLogAt.max || undefined" />
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong
                                                >Senaste kundaktivitet
                                                (t.o.m.)</strong
                                            >
                                            <input v-model="filterConfig.include.latestCustomerInitiatedActionLogAt.max" type="date" class="form-control" :min="filterConfig.include.latestCustomerInitiatedActionLogAt.min || undefined" />
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong
                                                >Signeringsdatum
                                                (fr.o.m.)</strong
                                            >

                                            <input v-model="filterConfig.include.primarySignatureAt.min" type="date" class="form-control" :max="filterConfig.include.primarySignatureAt.max || undefined" />
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong
                                                >Signeringsdatum
                                                (t.o.m.)</strong
                                            >
                                            <input v-model="filterConfig.include.primarySignatureAt.max" type="date" class="form-control" :min="filterConfig.include.primarySignatureAt.min || undefined" />
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-6">
                                    <div class="row">
                                        <div class="col-12 col-md-6 mb-3">
                                            <strong>Kund</strong>

                                            <v-select
                                                v-model="
                                                    filterConfig.include
                                                        .customerName
                                                "
                                                :options="
                                                    filterOptions.customerName
                                                "
                                                :reduce="(o) => o.value"
                                                multiple
                                            />
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong>Bolagsnamn</strong>

                                            <v-select
                                                v-model="
                                                    filterConfig.include
                                                        .clientCompany
                                                "
                                                :options="
                                                    filterOptions.clientCompany
                                                "
                                                :reduce="(o) => o.value"
                                                multiple
                                            />
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong>Säljare</strong>

                                            <v-select
                                                v-model="
                                                    filterConfig.include.seller
                                                "
                                                :options="filterOptions.seller"
                                                :reduce="(o) => o.value"
                                                multiple
                                            />
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong
                                                >Automatisk uppföljning</strong
                                            >

                                            <v-select
                                                v-model="
                                                    filterConfig.include
                                                        .flowStatus
                                                "
                                                :options="
                                                    filterOptions.flowStatus
                                                "
                                                :reduce="(o) => o.value"
                                                multiple
                                            />
                                        </div>

                                        <div
                                            v-if="
                                                filterOptions.quoteProfile
                                                    .length > 1
                                            "
                                            class="col-12 col-md-6 mb-3"
                                        >
                                            <strong>Profil</strong>

                                            <v-select
                                                v-model="
                                                    filterConfig.include
                                                        .quoteProfile
                                                "
                                                :options="
                                                    filterOptions.quoteProfile
                                                "
                                                :reduce="(o) => o.value"
                                                multiple
                                            />
                                        </div>

                                        <div
                                            v-if="
                                                (filterOptions.products || []).length >
                                                0
                                            "
                                            class="col-12 col-md-6 mb-3"
                                        >
                                            <strong>Produkter</strong>

                                            <v-select
                                                v-model="filterConfig.include.product"
                                                :options="filterOptions.products"
                                                :reduce="(option) => option.id"
                                                label="name"
                                                multiple
                                            >
                                                <template #option="product">
                                                    <div>
                                                        <strong>{{ product.name }}</strong><br />
                                                        <div class="text-muted" style="font-size: 70%">
                                                            {{ product.sku }}
                                                        </div>
                                                    </div>
                                                </template>
                                                <template #selected-option="product">
                                                    <div>
                                                        <strong>{{ product.name }}</strong><br />
                                                        <div class="text-muted" style="font-size: 70%">
                                                            {{ product.sku }}
                                                        </div>
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong>Status</strong>

                                            <v-select
                                                v-model="
                                                    filterConfig.include.status
                                                "
                                                :options="filterOptions.status"
                                                :reduce="(o) => o.value"
                                                multiple
                                            />

                                            <div
                                                class="custom-control custom-switch ml-1 mt-1"
                                            >
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :id="`${uuid}-filter-config-status-require-all`"
                                                    v-model="
                                                        filterConfig.include
                                                            .statusRequireAll
                                                    "
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="`${uuid}-filter-config-status-require-all`"
                                                    ><small
                                                        >Alla måste
                                                        matcha</small
                                                    ></label
                                                >
                                            </div>
                                        </div>

                                        <div
                                            v-if="(filterOptions.tags || []).length > 0"
                                            class="col-12 col-md-6 mb-3"
                                        >
                                            <strong>Taggar</strong>

                                            <v-select
                                                v-model="
                                                    filterConfig.include.tags
                                                "
                                                :options="filterOptions.tags"
                                                :reduce="(o) => o.value"
                                                multiple
                                            />

                                            <div
                                                class="custom-control custom-switch ml-1 mt-1"
                                            >
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :id="`${uuid}-filter-config-tags-require-all`"
                                                    v-model="
                                                        filterConfig.include
                                                            .tagsRequireAll
                                                    "
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="`${uuid}-filter-config-tags-require-all`"
                                                    ><small
                                                        >Alla måste
                                                        matcha</small
                                                    ></label
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">Exkludera</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-lg-6">
                                    <div class="row">
                                        <div class="col-12 col-md-6 mb-3">
                                            <strong>Datum (fr.o.m.)</strong>

                                            <input v-model="filterConfig.exclude.createdAt.min" type="date" class="form-control" :max="filterConfig.exclude.createdAt.max || undefined" />
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong>Datum (t.o.m.)</strong>
                                            <input v-model="filterConfig.exclude.createdAt.max" type="date" class="form-control" :min="filterConfig.exclude.createdAt.min || undefined" />
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong
                                                >Senaste kundaktivitet
                                                (fr.o.m.)</strong
                                            >

                                            <input v-model="filterConfig.exclude.latestCustomerInitiatedActionLogAt.min" type="date" class="form-control" :max="filterConfig.exclude.latestCustomerInitiatedActionLogAt.max || undefined" />
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong
                                                >Senaste kundaktivitet
                                                (t.o.m.)</strong
                                            >
                                            <input v-model="filterConfig.exclude.latestCustomerInitiatedActionLogAt.max" type="date" class="form-control" :min="filterConfig.exclude.latestCustomerInitiatedActionLogAt.min || undefined" />
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong
                                                >Signeringsdatum
                                                (fr.o.m.)</strong
                                            >

                                            <input v-model="filterConfig.exclude.primarySignatureAt.min" type="date" class="form-control" :max="filterConfig.exclude.primarySignatureAt.max || undefined" />
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong
                                                >Signeringsdatum
                                                (t.o.m.)</strong
                                            >
                                            <input v-model="filterConfig.exclude.primarySignatureAt.max" type="date" class="form-control" :min="filterConfig.exclude.primarySignatureAt.min || undefined" />
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-6">
                                    <div class="row">
                                        <div class="col-12 col-md-6 mb-3">
                                            <strong>Kund</strong>

                                            <v-select
                                                v-model="
                                                    filterConfig.exclude
                                                        .customerName
                                                "
                                                :options="
                                                    filterOptions.customerName
                                                "
                                                :reduce="(o) => o.value"
                                                multiple
                                            />
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong>Bolagsnamn</strong>

                                            <v-select
                                                v-model="
                                                    filterConfig.exclude
                                                        .clientCompany
                                                "
                                                :options="
                                                    filterOptions.clientCompany
                                                "
                                                :reduce="(o) => o.value"
                                                multiple
                                            />
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong>Säljare</strong>

                                            <v-select
                                                v-model="
                                                    filterConfig.exclude.seller
                                                "
                                                :options="filterOptions.seller"
                                                :reduce="(o) => o.value"
                                                multiple
                                            />
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong
                                                >Automatisk uppföljning</strong
                                            >

                                            <v-select
                                                v-model="
                                                    filterConfig.exclude
                                                        .flowStatus
                                                "
                                                :options="
                                                    filterOptions.flowStatus
                                                "
                                                :reduce="(o) => o.value"
                                                multiple
                                            />
                                        </div>

                                        <div
                                            v-if="
                                                filterOptions.quoteProfile
                                                    .length > 1
                                            "
                                            class="col-12 col-md-6 mb-3"
                                        >
                                            <strong>Profil</strong>

                                            <v-select
                                                v-model="
                                                    filterConfig.exclude
                                                        .quoteProfile
                                                "
                                                :options="
                                                    filterOptions.quoteProfile
                                                "
                                                :reduce="(o) => o.value"
                                                multiple
                                            />
                                        </div>

                                        <div
                                            v-if="
                                                (filterOptions.products || []).length >
                                                0
                                            "
                                            class="col-12 col-md-6 mb-3"
                                        >
                                            <strong>Produkter</strong>

                                            <v-select
                                                v-model="filterConfig.exclude.product"
                                                :options="filterOptions.products"
                                                :reduce="(option) => option.id"
                                                label="name"
                                                multiple
                                            >
                                                <template #option="product">
                                                    <div>
                                                        <strong>{{ product.name }}</strong><br />
                                                        <div class="text-muted" style="font-size: 70%">
                                                            {{ product.sku }}
                                                        </div>
                                                    </div>
                                                </template>
                                                <template #selected-option="product">
                                                    <div>
                                                        <strong>{{ product.name }}</strong><br />
                                                        <div class="text-muted" style="font-size: 70%">
                                                            {{ product.sku }}
                                                        </div>
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>

                                        <div class="col-12 col-md-6 mb-3">
                                            <strong>Status</strong>

                                            <v-select
                                                v-model="
                                                    filterConfig.exclude.status
                                                "
                                                :options="filterOptions.status"
                                                :reduce="(o) => o.value"
                                                multiple
                                            />

                                            <div
                                                class="custom-control custom-switch ml-1 mt-1"
                                            >
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :id="`${uuid}-filter-config-status-require-all`"
                                                    v-model="
                                                        filterConfig.exclude
                                                            .statusRequireAll
                                                    "
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="`${uuid}-filter-config-status-require-all`"
                                                    ><small
                                                        >Alla måste
                                                        matcha</small
                                                    ></label
                                                >
                                            </div>
                                        </div>

                                        <div
                                            v-if="(filterOptions.tags || []).length > 0"
                                            class="col-12 col-md-6 mb-3"
                                        >
                                            <strong>Taggar</strong>

                                            <v-select
                                                v-model="
                                                    filterConfig.exclude.tags
                                                "
                                                :options="filterOptions.tags"
                                                :reduce="(o) => o.value"
                                                multiple
                                            />

                                            <div
                                                class="custom-control custom-switch ml-1 mt-1"
                                            >
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :id="`${uuid}-filter-config-tags-require-all`"
                                                    v-model="
                                                        filterConfig.exclude
                                                            .tagsRequireAll
                                                    "
                                                />
                                                <label
                                                    class="custom-control-label"
                                                    :for="`${uuid}-filter-config-tags-require-all`"
                                                    ><small
                                                        >Alla måste
                                                        matcha</small
                                                    ></label
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3 d-flex justify-content-center">
                        <button
                            class="btn btn-primary btn-lg"
                            @click="handleFilter"
                        >
                            <i class="fal fa-search"></i> Sök
                        </button>
                    </div>
                </div>

                <slot name="after-filters"></slot>
            </div>

            <div v-else class="col-md-12 mb-4 text-center">
                <SbSpinner label="Laddar.."></SbSpinner>
            </div>

            <div class="col-md-12 mb-4" v-if="enableQuotesTable">
                <SbTable
                    :items="provideItems"
                    :fields="fields"
                    :primary-key="primaryKey"
                    :sort-by="sortBy"
                    :sort-desc="sortDesc"
                    :filter="combinedFilterConfig"
                    :current-page="currentPage"
                    :per-page="pageLimit"
                    thead-class="text-nowrap"
                    tbody-tr-class="text-nowrap"
                    responsive
                >
                    <template #cell(created_at)="data">
                        <a
                            :href="route('quotes.edit', data.item.id)"
                            target="_blank"
                            class="text-decoration-none text-dark"
                        >
                            {{ data.value }}
                        </a>
                    </template>

                    <template #cell(customer_name)="data">
                        {{ data.value }}
                        <template v-if="showContactMethods">
                            <i
                                v-if="data.item.customer_phone"
                                class="fa-light fa-mobile"
                                :title="data.item.customer_phone"
                            ></i>
                            <i
                                v-if="data.item.customer_email"
                                class="fa-light fa-envelope"
                                :title="data.item.customer_email"
                            ></i>
                        </template>
                    </template>

                    <template #cell(client_company)="data">
                        <small
                            v-if="data.value === 'Privatkund'"
                            style="opacity: 0.5"
                        >
                            {{ data.value }}
                        </small>
                        <small v-else>
                            {{ data.value }}
                        </small>
                    </template>

                    <template #cell(formatted_quote_value)="data">
                        <div v-html="data.value"></div>
                    </template>

                    <template #cell(statuses)="data">
                        <a
                            v-for="(statusItem, statusIdx) in data.value"
                            :key="statusIdx"
                            :href="statusItem.href"
                            class="mr-1"
                        >
                            <SbBadge pill :variant="statusItem.type">
                                {{ statusItem.title }}
                                <i
                                    v-if="statusItem.icon"
                                    :class="`fal fa-${statusItem.icon} ml-1`"
                                ></i>
                            </SbBadge>

                            <br />
                        </a>
                        <SbBadge pill variant="secondary" class="mr-1">
                            Automatisk uppföljning: {{ data.item.flow_status }}
                            <i class="fal fa-paper-plane ml-1"></i>
                        </SbBadge>
                    </template>

                    <template #cell(tags)="data">
                        <SbBadge
                            v-for="(tagItem, tagIdx) in data.value"
                            :key="tagIdx"
                            class="ml-1"
                            pill
                            variant="secondary"
                        >
                            {{ tagItem }}
                        </SbBadge>
                    </template>

                    <template #cell(related_products)="data">
                        <ul
                            v-if="
                                showProductsQuoteIds.indexOf(data.item.id) !==
                                -1
                            "
                            class="list-unstyled mb-0"
                        >
                            <li
                                v-for="(prod, prodIdx) in data.value"
                                :key="prodIdx"
                                class="ml-1"
                            >
                                {{ prod.name }}<br />
                                <div class="text-muted" style="font-size: 70%">
                                    {{ prod.sku }}
                                </div>
                            </li>
                        </ul>
                        <button
                            v-else-if="data.value.length > 0"
                            type="button"
                            class="btn btn-sm btn-primary"
                            @click="showProductsQuoteIds.push(data.item.id)"
                        >
                            Visa {{ data.value.length }} st
                        </button>
                    </template>
                </SbTable>

                <div
                    class="mt-3 d-flex flex-column justify-content-center align-items-center"
                >
                    <SbSpinner v-if="!isLoaded" label="Laddar.."></SbSpinner>
                </div>

                <div
                    class="d-flex justify-content-center align-items-center mt-3"
                >
                    <SbPagination
                        class="w-full"
                        v-model="currentPage"
                        :total-rows="quoteCount"
                        :per-page="pageLimit"
                    ></SbPagination>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.v-select:deep(.vs__dropdown-toggle) {
    min-height: 37.04px;
}
</style>

<script setup lang="ts">
import axios from 'axios';
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { route } from 'ziggy-js';
import { v4 as uuidv4 } from 'uuid';
import { downloadProducts } from '../products/downloadProducts';
import { formatSignableUntil } from '../quotes/formatSignableUntil';
import SbBadge from '../sb/SbBadge.vue';
import SbPagination from '../sb/SbPagination.vue';
import SbSpinner from '../sb/SbSpinner.vue';
import SbTable from '../sb/SbTable.vue';

interface FilterSide { createdAt: { min: string | null; max: string | null }; latestCustomerInitiatedActionLogAt: { min: string | null; max: string | null }; primarySignatureAt: { min: string | null; max: string | null }; quoteProfile: unknown[]; customerName: unknown[]; clientCompany: unknown[]; seller: unknown[]; status: unknown[]; statusRequireAll: boolean; flowStatus: unknown[]; tags: unknown[]; tagsRequireAll: boolean; product: unknown[] }
interface FilterConfig { include: FilterSide & Record<string, unknown>; exclude: FilterSide & Record<string, unknown> }
interface AnalysisQuoteRow { custom_fields?: { name: string; label: string; value: unknown }[] }
interface TableContext { sortBy?: string; sortDesc?: boolean; currentPage: number; perPage: number; filter: unknown }
const props = withDefaults(defineProps<{ enableQuotesTable?: boolean; baseFilterConfig?: Partial<FilterConfig>; showContactMethods?: boolean }>(), { enableQuotesTable: true, baseFilterConfig: () => ({ include: {}, exclude: {} }), showContactMethods: false });
const emit = defineEmits<{ (event: 'filterConfig', config: FilterConfig): void; (event: 'quoteCount', count: number | null): void }>();
const emptySide = (): FilterSide => ({ createdAt: { min: null, max: null }, latestCustomerInitiatedActionLogAt: { min: null, max: null }, primarySignatureAt: { min: null, max: null }, quoteProfile: [], customerName: [], clientCompany: [], seller: [], status: [], statusRequireAll: false, flowStatus: [], tags: [], tagsRequireAll: false, product: [] });
const FIELDS = [
{ key: 'created_at', label: 'Datum', sortable: true, formatter: (value: string) => value.substring(0, 10), sortByFormatted: true },
{ key: 'quote_profile_name', label: 'Profil', sortable: true }, { key: 'customer_name', label: 'Kund', sortable: true }, { key: 'customer_email', label: 'E-post', sortable: false }, { key: 'customer_phone', label: 'Telefon', sortable: false },
{ key: 'person_number', label: 'Personnummer', sortable: false, formatter: (value: unknown) => value || 'N/A' }, { key: 'customer_age', label: 'Ålder', sortable: false, formatter: (value: unknown) => value || 'N/A' }, { key: 'customer_sex', label: 'Kön', sortable: false, formatter: (value: unknown) => value || 'N/A' },
{ key: 'client_company', label: 'Bolagsnamn', sortable: true, formatter: (value: unknown) => value || 'Privatkund' }, { key: 'formatted_quote_value', label: 'Värde', sortable: true },
{ key: 'latest_customer_initiated_action_log_at', label: 'Kundaktivitet', formatter: (value: string | null) => value ? value.substring(0, 10) : '-' }, { key: 'last_seller_activity_at', label: 'Redigerad', formatter: (value: string | null) => value ? value.substring(0, 10) : '-' },
{ key: 'primary_signature_at', label: 'Signerings', sortable: true, sortDirection: 'desc', formatter: (value: string | null) => value ? value.substring(0, 10) : '-' }, { key: 'signable_until', label: 'Giltig tom', sortable: true, formatter: formatSignableUntil },
{ key: 'seller', label: 'Kontakt', sortable: true, formatter: (value: { name: string } | null) => value?.name || '-' },
{ key: 'email_consent', label: 'Nyhetsbrev', sortable: false }, { key: 'statuses', label: 'Status', sortable: false }, { key: 'tags', label: 'Taggar', sortable: false },
...Array.from({ length: 10 }, (_, index) => ({ key: `custom_field_${index + 1}_content`, label: `Fält ${index + 1}`, sortable: false })), { key: 'related_products', label: 'Produkter', sortable: false },
];
const uuid = uuidv4(); const primaryKey = 'id'; const sortBy = ref('created_at'); const sortDesc = ref(true);
const filterConfig = reactive<FilterConfig>({ include: emptySide(), exclude: emptySide() });
const combinedFilterConfig = ref<Record<string, unknown>>({});
const filterOptions = reactive<Record<string, any[]>>({ quoteProfile: [], customerName: [], clientCompany: [], seller: [], status: [], flowStatus: [], products: [], tags: [] });
const filterOptionsLoaded = ref(false); const quoteProfileNameCount = ref(0); const showProductsQuoteIds = ref<number[]>([]); const tagCount = ref(0); const productCount = ref(0); const isLoaded = ref(false); const currentPage = ref(1); const pageLimit = 50; const quoteCount = ref<number | null>(null);
const customFieldLabels = ref<string[]>([]);
/** One column per custom fields v2 label seen in the loaded rows; v1 answers stay in the "Fält N" columns. */
const customFieldColumns = computed(() => customFieldLabels.value.map((label, index) => ({ key: `custom_fields_v2_${index}`, label, sortable: false, formatter: (_value: unknown, _key: string, item: AnalysisQuoteRow) => item.custom_fields?.find(field => field.label === label)?.value ?? '' })));
function addCustomFieldLabels(quotes: AnalysisQuoteRow[]): void { const labels = quotes.flatMap(quote => (quote.custom_fields ?? []).map(field => field.label)).filter(label => !customFieldLabels.value.includes(label)); customFieldLabels.value = [...customFieldLabels.value, ...new Set(labels)]; }
const fields = computed(() => { const columns = FIELDS.filter(field => field.key !== 'quote_profile_name' || quoteProfileNameCount.value > 1).filter(field => field.key !== 'tags' || tagCount.value > 0).filter(field => field.key !== 'related_products' || productCount.value > 0); const productsIndex = columns.findIndex(field => field.key === 'related_products'); return productsIndex === -1 ? [...columns, ...customFieldColumns.value] : [...columns.slice(0, productsIndex), ...customFieldColumns.value, ...columns.slice(productsIndex)]; });
watch(quoteCount, value => emit('quoteCount', value), { immediate: true });
async function updateFilterOptions(): Promise<void> { const { data } = await axios.get(route('data_analysis.quotes.filterOptions')); filterOptions.quoteProfile = data.quote_profiles; filterOptions.customerName = data.customer_names; filterOptions.clientCompany = [{ value: null, label: 'Privatkund' }, ...data.client_companies]; filterOptions.status = data.statuses; filterOptions.seller = data.sellers; filterOptions.flowStatus = data.flow_statuses; filterOptions.tags = data.tags; filterOptions.products = await downloadProducts(); filterOptionsLoaded.value = true; }
async function provideItems(ctx: TableContext): Promise<any[]> { try { const sort = ctx.sortBy ? { sort_by: ctx.sortBy, sort_desc: ctx.sortDesc ? 1 : 0 } : {}; const response = await axios.get(route('data_analysis.quotes.index', { _query: { page: ctx.currentPage, per_page: ctx.perPage, ...sort, filter_config: ctx.filter } })); const quotes = response.data.data; quoteProfileNameCount.value += new Set(quotes.map((item: any) => item.quote_profile_name)).size; tagCount.value += new Set(quotes.flatMap((item: any) => item.tags)).size; productCount.value += new Set(quotes.flatMap((item: any) => item.related_products)).size; addCustomFieldLabels(quotes); quoteCount.value = response.data.meta.total; return quotes; } catch (error) { console.error(error); return []; } finally { isLoaded.value = true; } }
function combineFilterConfig(): Record<string, unknown> { const combined: any = JSON.parse(JSON.stringify(props.baseFilterConfig)); combined.include ||= {}; combined.exclude ||= {}; const local: any = JSON.parse(JSON.stringify(filterConfig)); for (const key of ['include', 'exclude']) { for (const field of Object.keys(local[key])) { const value = local[key][field]; if (Array.isArray(combined[key][field])) { combined[key][field] = combined[key][field].concat(value); } else if (!combined[key][field]) { combined[key][field] = value; } else { throw new Error('Invalid filter config!'); } } } emit('filterConfig', JSON.parse(JSON.stringify(combined)) as FilterConfig); return combined; }
function handleFilter(): void { combinedFilterConfig.value = combineFilterConfig(); }
onMounted(async () => { await updateFilterOptions(); combinedFilterConfig.value = combineFilterConfig(); if (!props.enableQuotesTable) { isLoaded.value = true; } });
</script>
